import type { PricingPlan } from 'Services/ProductManagement/Features/Product/productSlice'

/**
 * Generates a unique title for a pricing plan based on its properties. Pricings and title
 * are excluded from the generated title.
 */
export const generatePricingPlanTitle = (pricingPlan: PricingPlan, productId: string): string => {
  const {
    active_period,
    custom_fields,
    description,
    domicile_class,
    visible_period,
    usage_validity_duration,
    vat_code,
    zone_map
  } = pricingPlan

  return `${productId}-${JSON.stringify(active_period)}-${JSON.stringify(
    custom_fields
  )}-${description}-${domicile_class}-${JSON.stringify(
    visible_period
  )}-${usage_validity_duration}-${vat_code}-${zone_map.join('')}`
}

/**
 * Loops through the pricing plans and adds a unique title to each pricing plan and its pricings.
 */
export const addUniqueTitleToPricingPlans = (
  pricingPlans: PricingPlan[],
  productId: string
): PricingPlan[] => {
  return pricingPlans.map(pricingPlan => ({
    ...pricingPlan,
    title: generatePricingPlanTitle(pricingPlan, productId),
    pricings: pricingPlan.pricings.map(pricing => ({
      ...pricing,
      title: generatePricingPlanTitle(pricingPlan, productId)
    }))
  }))
}
